import React, { useState, useEffect } from 'react';
import {
  PageHeader
} from 'antd';
import Breadcrumb from 'components/BreadCrumb';
import {
  fetchTheme, fetchSubTheme
} from 'utils/themes';
import Skeleton from 'components/Spins/Skeleton';
import { fetchRecipe } from 'utils/recipes';
import RecipeForm from 'containers/computers/form/Edit';
import styled from 'styled-components';

const EditRecipe = props => {
  const [recipe, setRecipe] = useState(null);
  const [themes, setThemes] = useState([]);
  const [subThemes, setSubThemes] = useState([]);
  const [show, setShow] = useState(false);

  console.log(show);

  useEffect(() => {
    const { match: { params: { recipeId } } } = props;
    fetchTheme().then(themesData => {
      setThemes(themesData);
      fetchSubTheme().then(subThemesData => {
        setSubThemes(subThemesData);
        if (recipeId) {
          fetchRecipe(recipeId)
            .then((recipeData) => {
              setRecipe(recipeData);
            });
        } else {
          const { recipeFromProps } = props;
          if (recipeFromProps) {
            setRecipe(recipeFromProps);
          }
        }
      });
    });
  }, []);

  const renderSpinOrContent = () => {
    if (!recipe) {
      return (
        <Skeleton />
      );
    }
    return (
      <>
        <PageHeader
          style={{ border: '1px solid #d9d9d9' }}
          title="Calculateur"
          breadcrumb={(
            <Breadcrumb
              items={[
                ['Accueil', '/'],
                ['Calculateur'],
              ]}
            />
          )}
        />
        <InnerContent>
          <RecipeForm
            themes={themes}
            subThemes={subThemes}
            setShow={setShow}
            recipe={recipe}
            isEdit
          />
        </InnerContent>
      </>
    );
  };

  return (
    renderSpinOrContent()
  );
};

export default EditRecipe;

const InnerContent = styled.div`
  background: #fff;
  margin: 0px;
  margin-top: 20px;
`;
